<template>
<div>
	<h1>Help</h1>
</div>
</template>

<script>
export default {
	name: "help-view"
};
</script>

<style scoped>

</style>


// WEBPACK FOOTER //
// src/components/Help.vue